import { computed, Ref } from 'vue';
import { AutoTabKey, JudicialAutomationModel } from '@/components/automation/judicial/types';
import {
  fieldsUniter,
  getCheckbox,
} from '@/components/automation/judicial/tabs/utils';
import { ActiveFormFieldType } from '@/hooks/useActiveForm';
import { ITextInputType } from '@/components/textInput/useTextInput';

export const getAutoDebtorsActions = (
  model: Ref<JudicialAutomationModel>,
  localT: (s: string) => string,
) => {
  return fieldsUniter(AutoTabKey.debtorsActions, [
    {
      key: 'enable_min_judicial_debt_amount_for_filling_in_court',
      field: 'enable_min_judicial_debt_amount_for_filling_in_court',
      type: ActiveFormFieldType.checkbox,
      options: {
        state: ['primary', 'short'],
      },
      onUpdateModelValue: (updatedModel: JudicialAutomationModel) => {
        const value = updatedModel.enable_min_judicial_debt_amount_for_filling_in_court;

        if (!value) {
          model.value.min_judicial_debt_amount_for_filling_in_court = 0;
        } else {
          model.value.min_judicial_debt_amount_for_filling_in_court = null;
        }
      },
    },
    {
      key: 'enable_min_judicial_debt_amount_for_fee_register',
      field: 'enable_min_judicial_debt_amount_for_fee_register',
      type: ActiveFormFieldType.checkbox,
      options: {
        state: ['primary', 'short'],
      },
      onUpdateModelValue: (updatedModel: JudicialAutomationModel) => {
        const value = updatedModel.enable_min_judicial_debt_amount_for_fee_register;

        if (!value) {
          model.value.min_judicial_debt_amount_for_fee_register = 0;
        } else {
          model.value.min_judicial_debt_amount_for_fee_register = null;
        }
      },
    },
    {
      key: 'min_judicial_debt_amount_for_filling_in_court',
      field: 'min_judicial_debt_amount_for_filling_in_court',
      type: ActiveFormFieldType.range,
      state: ['primary'],
      options: {
        min: 0,
        max: 1000000,
        tooltipPosition: 'bottom',
        withManualInput: true,
        ignoreCheckManualLimits: true,
        isDisabled: !model.value.enable_min_judicial_debt_amount_for_filling_in_court,
      },
    },
    {
      key: 'min_judicial_debt_amount_for_fee_register',
      field: 'min_judicial_debt_amount_for_fee_register',
      type: ActiveFormFieldType.range,
      state: ['primary'],
      options: {
        min: 0,
        max: 1000000,
        tooltipPosition: 'bottom',
        withManualInput: true,
        ignoreCheckManualLimits: true,
        isDisabled: !model.value.enable_min_judicial_debt_amount_for_fee_register,
      },
    },
    getCheckbox('move_judicial_debtors_without_debt_to_archive', model, localT),
    getCheckbox('exclude_when_died', model, localT),
    getCheckbox('exclude_with_deregistration_date', model, localT),
    getCheckbox('include_children', model, localT),
    getCheckbox('allow_without_court', model, localT),
    getCheckbox('show_administrative_district_filter', model, localT),
    getCheckbox('send_joint_ownership_letters_separately', model, localT),
    getCheckbox('send_solidary_debtors_letters_separately', model, localT),
    getCheckbox('court_order_period_after_canceled_judgment', model, localT),
    getCheckbox('pochta_ru_send_to_legal_address', model, localT),
  ]);
};
